import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/styles';
import {Typography} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import {useTranslation} from 'react-i18next';
import {Skype as SkypeIcon, Viber as ViberIcon} from '../../../../icons';
import {Link as RouterLink} from 'react-router-dom';
import Link from '@material-ui/core/Link';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import PhoneIcon from '@material-ui/icons/Phone';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import RoomIcon from '@material-ui/icons/Room';
import FooterLists from './components/FooterLists/FooterLists';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Hidden from '@material-ui/core/Hidden';
import ContactLink from './components/ContactLink';
import FooterNav from './components/FooterNav/FooterNav';
import footer_logo from '../../../../images/logo_header_work.svg';

const useStyles = makeStyles(theme => ({
  root: {
    // padding: theme.spacing(4),
  },
}));

const Footer = props => {
  const {className, frontendData, ...rest} = props;

  const classes = useStyles();
  const {t} = useTranslation();

  // let sb_phone_const = {
  //     title: '+??? (??) ???-??-??',
  //     href: '',
  //     icon: <PhoneIcon/>,
  //     icon2: '',
  // };

  let custom_text_phone = [
    {
      title: `+38 067 360-12-00 (${t('common:cargo_department')})`,
      href: 'tel:+380673601200',
      icon: <PhoneIcon />,
      // icon2: <ViberIcon />,
    },
    // {
    //   title: '+38 067 360-12-00',
    //   href: 'tel:+38 067 360-12-00',
    //   icon: <PhoneIcon />,
    //   icon2: <ViberIcon />,
    // },
    {
      title: `+38 093 311-69-83 (${t('common:electronics_department')})`,
      href: 'tel:+380933116983',
      icon: <PhoneIcon />,
      icon2: '',
    },
    {
      title: `+38 063 112-74-25 (${t('common:car_department')})`,
      href: 'tel:+380631127425',
      icon: <PhoneIcon />,
      icon2: '',
    },
    {
      title: `+38 063 602-72-50 (${t('common:alternative_energy_department')})`,
      href: 'tel:+380636027250',
      icon: <PhoneIcon />,
      icon2: '',
    },
    {
      title: `+38 050 086-05-85 (${t('common:electro_vegicle_group')})`,
      href: '+380500860585',
      icon: <PhoneIcon />,
      icon2: '',
    },
    {
      title: `+38 067 616-12-00 (${t('common:bookkeeping')})`,
      href: 'tel:+380676161200',
      icon: <PhoneIcon />,
      icon2: '',
    },

    // {
    //     title: '+38 067 231-69-34',
    //     href: 'fax:+38 067 231-69-34',
    //     icon: <FaxIcon/>,
    //     icon2: '',
    // },
  ];

  // let last_number = 0;
  // let SbPhone = [];
  // SbPhone[0] = {...sb_phone_const};
  // let t_phone = [];
  // if (frontendData.phone_primary !== null) t_phone = frontendData.phone_primary;
  // else if (frontendData.phones_secondary !== null)
  //     t_phone = frontendData.phones_secondary;
  // else t_phone = [];
  //
  //
  // if (t_phone !== undefined) {
  //
  //     last_number = t_phone.length;
  //
  //     for (let i in t_phone) {
  //         sb_phone_const.title = t_phone[i].number;
  //         sb_phone_const.href = `tel:${t_phone[i].number}`;
  //         SbPhone[i] = {...sb_phone_const};
  //     }
  //
  //
  //     for (let i in custom_text_phone) {
  //         sb_phone_const.title = custom_text_phone[i].title;
  //         sb_phone_const.href = `tel:${custom_text_phone[i].href}`;
  //         SbPhone[i+last_number] = {...sb_phone_const};
  //     }
  //
  //
  // }

  // SbPhone[last_number+1]= {...custom_text_phone};

  const schedule_arr = [
    {title: t('common:schedule1'), href: '/'},
    {title: t('common:schedule2'), href: '/'},
    {title: t('common:schedule3'), href: '/'},
    {title: t('common:schedule4'), href: '/'},
    {title: t('common:schedule5'), href: '/'},
    {title: t('common:Shipment_order'), href: '/'},
  ];
  let contact_info_2 = [
    {
      title: 'daniparts',
      href: 'skype:daniparts?chat',
      icon: <SkypeIcon />,
      icon2: '',
    },
    {
      title: 'rviparts',
      href: 'skype:rviparts?chat',
      icon: <SkypeIcon />,
      icon2: '',
    },
    {
      title: 'rviparts@gmail.com',
      href: 'mailto:rviparts@gmail.com',
      icon: <AlternateEmailIcon />,
      icon2: '',
    },
    {
      title: t('common:company_location'),
      href: 'https://goo.gl/maps/YgFq3eiBRjyxmor5A',
      icon: <RoomIcon />,
      icon2: '',
      target: 'blank',
    },
  ];

  const SbCompanyInfo = [
    {
      title: t('common:about-us'),
      href: '/about-us',
      icon: (
        <svg
          width="14"
          height="12"
          viewBox="0 0 14 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7 0.00195313C6.73762 0.00195312 6.47781 0.0536329 6.2354 0.154042C5.99299 0.254451 5.77273 0.401622 5.5872 0.587154C5.40167 0.772685 5.2545 0.992943 5.15409 1.23535C5.05368 1.47776 5.002 1.73757 5.002 1.99995C5.002 2.26233 5.05368 2.52215 5.15409 2.76455C5.2545 3.00696 5.40167 3.22722 5.5872 3.41275C5.77273 3.59828 5.99299 3.74546 6.2354 3.84586C6.47781 3.94627 6.73762 3.99795 7 3.99795C7.5299 3.99795 8.0381 3.78745 8.4128 3.41275C8.7875 3.03805 8.998 2.52986 8.998 1.99995C8.998 1.47005 8.7875 0.961851 8.4128 0.587154C8.0381 0.212456 7.5299 0.00195313 7 0.00195313ZM11.5 0.999953C11.1022 0.999953 10.7206 1.15799 10.4393 1.43929C10.158 1.7206 10 2.10213 10 2.49995C10 2.89778 10.158 3.27931 10.4393 3.56061C10.7206 3.84192 11.1022 3.99995 11.5 3.99995C11.8978 3.99995 12.2794 3.84192 12.5607 3.56061C12.842 3.27931 13 2.89778 13 2.49995C13 2.10213 12.842 1.7206 12.5607 1.43929C12.2794 1.15799 11.8978 0.999953 11.5 0.999953ZM2.5 0.999953C2.10218 0.999953 1.72064 1.15799 1.43934 1.43929C1.15804 1.7206 1 2.10213 1 2.49995C1 2.89778 1.15804 3.27931 1.43934 3.56061C1.72064 3.84192 2.10218 3.99995 2.5 3.99995C2.89783 3.99995 3.27936 3.84192 3.56066 3.56061C3.84197 3.27931 4 2.89778 4 2.49995C4 2.10213 3.84197 1.7206 3.56066 1.43929C3.27936 1.15799 2.89783 0.999953 2.5 0.999953ZM4 5.99295C4.00185 5.72895 4.10802 5.47639 4.29536 5.29037C4.48269 5.10434 4.73599 4.99995 5 4.99995H9C9.26522 4.99995 9.51957 5.10531 9.70711 5.29285C9.89464 5.48038 10 5.73474 10 5.99995V8.99995C10.0003 9.3147 9.95099 9.62753 9.854 9.92695C9.63257 10.6057 9.17644 11.1832 8.56751 11.5559C7.95859 11.9285 7.23675 12.0719 6.53163 11.9602C5.8265 11.8486 5.18428 11.4892 4.72028 10.9466C4.25628 10.4041 4.0009 9.71386 4 8.99995V5.99295ZM3 5.99995C3 5.63495 3.097 5.29395 3.268 4.99995H1C0.734784 4.99995 0.48043 5.10531 0.292893 5.29285C0.105357 5.48038 1.38413e-07 5.73474 1.38413e-07 5.99995V8.49995C-0.000136048 8.90926 0.100226 9.31234 0.292273 9.67379C0.48432 10.0352 0.762177 10.344 1.10144 10.573C1.44071 10.802 1.831 10.9441 2.23806 10.987C2.64511 11.0299 3.05646 10.9722 3.436 10.819C3.14879 10.2553 2.99937 9.63156 3 8.99895V5.99995ZM11 5.99995V8.99995C11 9.65495 10.843 10.273 10.564 10.819C10.9435 10.9722 11.3549 11.0299 11.7619 10.987C12.169 10.9441 12.5593 10.802 12.8986 10.573C13.2378 10.344 13.5157 10.0352 13.7077 9.67379C13.8998 9.31234 14.0001 8.90926 14 8.49995V5.99995C14 5.73474 13.8946 5.48038 13.7071 5.29285C13.5196 5.10531 13.2652 4.99995 13 4.99995H10.732C10.902 5.29395 11 5.63495 11 5.99995Z"
            fill="#C8CAD8"
          />
        </svg>
      ),
      icon2: '',
    },
    {
      title: t('common:blog'),
      href: '/blog',
      icon: (
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 0V12H12V0H0ZM10 10H2V9.33333H10V10ZM10 8.66667H2V8H10V8.66667ZM10 6H2V2H10V6Z"
            fill="#C8CAD8"
          />
        </svg>
      ),
      icon2: '',
    },
    {
      title: t('common:delivery_and_payment'),
      href: '/delivery',
      icon: (
        <svg
          width="14"
          height="13"
          viewBox="0 0 14 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.3335 6.00008C10.0668 6.00008 9.00016 7.06675 9.00016 8.33342C9.00016 10.0667 11.3335 12.6667 11.3335 12.6667C11.3335 12.6667 13.6668 10.0667 13.6668 8.33342C13.6668 7.06675 12.6002 6.00008 11.3335 6.00008ZM11.3335 9.20008C10.8668 9.20008 10.5335 8.80008 10.5335 8.40008C10.5335 7.93342 10.9335 7.60008 11.3335 7.60008C11.7335 7.60008 12.1335 8.00008 12.1335 8.40008C12.2002 8.80008 11.8002 9.20008 11.3335 9.20008ZM8.70016 11.3334H1.66683C1.31321 11.3334 0.974069 11.1929 0.72402 10.9429C0.473972 10.6928 0.333496 10.3537 0.333496 10.0001V2.00008C0.333496 1.64646 0.473972 1.30732 0.72402 1.05727C0.974069 0.807224 1.31321 0.666748 1.66683 0.666748H12.3335C13.0735 0.666748 13.6668 1.26008 13.6668 2.00008V5.53341C13.2768 5.204 12.8229 4.95886 12.3335 4.81342V3.33341H1.66683V5.33342H9.26016C8.30683 6.00008 7.66683 7.10675 7.66683 8.33342C7.66683 9.33342 8.14683 10.4067 8.70016 11.3334Z"
            fill="#FFBE00"
          />
        </svg>
      ),
      icon2: '',
    },
    {
      title: t('common:contacts'),
      href: '/contacts',
      icon: (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.5 1H3.5C2.6675 1 2 1.6408 2 2.44V13.96C2 14.7592 2.6675 15.4 3.5 15.4H12.5C13.3325 15.4 14 14.7592 14 13.96V5.32L9.5 1ZM11.75 13.5568C11.75 13.78 11.5625 13.96 11.33 13.96C7.4225 13.96 4.25 10.9144 4.25 7.1632C4.25 6.94 4.4375 6.76 4.67 6.76H6.125C6.3575 6.76 6.545 6.94 6.545 7.1632C6.545 7.66 6.6275 8.1424 6.7775 8.5888C6.8225 8.7256 6.7925 8.884 6.6725 8.9992L5.75 9.8776C6.3575 11.008 7.325 11.9368 8.5025 12.52L9.425 11.6344C9.5375 11.5192 9.7025 11.4904 9.845 11.5336C10.31 11.6776 10.8125 11.764 11.3375 11.764C11.5625 11.764 11.75 11.9368 11.75 12.16V13.5568ZM8.75 6.04V2.08L12.875 6.04H8.75Z"
            fill="#C8CAD8"
          />
        </svg>
      ),
      icon2: '',
    },
    // {
    //   title: t('common:payment'),
    //   href: '/payment',
    //   icon: '',
    //   icon2: '',
    // },
    {
      title: t('common:warranty'),
      href: '/warranty',
      icon: '',
      icon2: '',
    },
    {
      title: t('common:return_terms'),
      href: '/return_terms',
      icon: '',
      icon2: '',
    },
    {
      title: t('common:user_agreement'),
      href: '/user_agreement',
      icon: '',
      icon2: '',
    },
    {
      title: t('common:offer_agreement'),
      href: '/offer_agreement',
      icon: '',
      icon2: '',
    }
  ];

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    // combine classes
    <footer
      {...rest}
      className={clsx(classes.root, className, 'footer')}
      id="footer">
      <div className="footer__top">
        <div className="wrapper-inner">
          <div className="row">
            <div className="col-12">
              <div className="footer__top-inner">
                <RouterLink to="/" className="footer__logo">
                  <img src={footer_logo} />
                </RouterLink>
                <FooterNavItems
                  pages={SbCompanyInfo}
                  title={t('common:information')}
                />
                <FooterNavItems
                  pages={custom_text_phone}
                  title={t('common:contacts')}
                />
                <FooterNavItems
                  pages={contact_info_2}
                  title={t('common:contacts')}
                />
                <FooterNavItems
                  pages={schedule_arr}
                  title={t('common:schedule')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer__bot d-xxl-none">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="footer__copyright">
                © 2010-{new Date().getFullYear()} | Daniparts, Inc. All Rights
                Reserved
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
};

export default Footer;

const FooterNavItems = ({pages, title}) => {
  return (
    <div className="footer__navs-item">
      <div className="footer__navs-title">{title}</div>
      <ul className="footer__nav">
        {pages.map(page => (
          <li key={page.title} className="d-flex gap-10">
            {page.icon ? (
              <>
                {page.icon}
                {page.href.startsWith('tel:') ||
                page.href.startsWith('mailto:') ||
                page.href.startsWith('skype:') ||
                page.target ? (
                  <a
                    target={page.target ? `_${page.target}` : ''}
                    href={page.href}>
                    {page.title}
                  </a>
                ) : (
                  <RouterLink to={page.href}>{page.title}</RouterLink>
                )}
                {page.icon2}
              </>
            ) : (
              <RouterLink to={page.href}>{page.title}</RouterLink>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
